export const countryConfigIT = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 5,
      starredCards1: true,
      starredCards2: true,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'per-bici',
    carCollection: 'per-auto'
  },
  'landing-custom-products': {
    quickCustomization: 'express-2',
    proCustomization: 'pro-3d-1',
    design: 'pro-3d-1',
    logo: 'pro-3d-1'
  }
};
